import React from 'react';

export default function ResourcesIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M16 0.5H2C0.89 0.5 0 1.45 0 2.61111V17.3889C0 18.55 0.89 19.5 2 19.5H16C17.1 19.5 18 18.55 18 17.3889V2.61111C18 1.45 17.1 0.5 16 0.5ZM14 11.0556H10V15.2778H8V11.0556H4V8.94444H8V4.72222H10V8.94444H14V11.0556Z"
      />
    </svg>
  );
}
